import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import SeriesForm from './forms/seriesForm';
import SeriesList from './lists/seriesList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {ProductColumn} from "../../utils/formatters";

class seriesEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Sorozatok"}
                    footer={[
                        <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <SeriesList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Sorozat"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <SeriesForm {...this.props} />
                </Editor>
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    <Box
                        theme="default"
                        header="Termékek"
                    >
                        <SelectorGrid
                            columns={{
                                "displayname": {
                                    ...ProductColumn("product_id"),
                                    width: 2,
                                }
                            }}
                            listfield={"products"}
                            listfieldlabel={"displayname"}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            {...this.props.getFieldProps("products")}
                        />
                    </Box>
                }
            </Fragment>
        );
    }
}

export default createEditor({componentName: "series", WrappedComponent: seriesEditor, props: {view: "admin"}});
